import { api } from "./api";

export const customizeOptions = api.injectEndpoints({
  endpoints: builder => ({
    getActivityInterest: builder.query({
      query: (params) => {
        return {
          url: `${process.env.REACT_APP_API_URL}/users/profile/customize/options/?option=${params}`,
        }
      },
      keepUnusedDataFor: 5,
    }),
    getUser: builder.query({
      query: () => {
        return {
          url: `${process.env.REACT_APP_API_URL}/users/me/`,
        }
      },
    }),
    updateUserAdditionalInfo: builder.mutation({
      query: (payload) => {
        return {
          url: `${process.env.REACT_APP_API_URL}/users/profile/customize/`,
          method: 'PATCH',
          body: {
            nearest_city: payload.nearest_city,
            nearest_airport: payload.nearest_airport,
            unit_system: payload.unit_system,
            travel_preference: payload.travel_preference,
            is_inviting_others: payload.is_inviting_others,
            budget_preference: payload.budget_preference,
            pace_preference: payload.pace_preference,
            primary_travel_purposes: payload.primary_travel_purposes,
            destination_types: payload.destination_types,
            activity_interests: payload.activity_interests,
            trip_planning_style: payload.trip_planning_style,
          }
        }
      },
    }),
    updateUserInfo: builder.mutation({
      query: ({ 
        id,
        first_name,
        last_name,
        email,
        username,
        gender,
        age_group,
        country,
        nearest_city_and_airport,
        chosen_plan,
        primary_travel_purposes,
        destination_types,
        activity_interests,
        travel_preference,
        budget_preference,
        pace_preference,
      }) => {
        return {
          url: `${process.env.REACT_APP_API_URL}/users/me/`,
          method: 'PATCH',
          body: {
            id,
            first_name,
            last_name,
            email,
            username,
            gender,
            age_group,
            country,
            nearest_city_and_airport,
            chosen_plan,
            primary_travel_purposes,
            destination_types,
            activity_interests,
            travel_preference,
            budget_preference,
            pace_preference,
          },
        }
      },
    }),
    updatePlan: builder.mutation({
      query: ({ plan_id }) => {
        return {
          url: `${process.env.REACT_APP_API_URL}/users/plans/${plan_id}/`,
          method: 'POST',
          body: {
            plan_id: plan_id,
          }
        }
      },
    }),
  })
});

export const {
  useGetActivityInterestQuery,
  useGetUserQuery,
  useUpdateUserInfoMutation,
  useUpdateUserAdditionalInfoMutation,
  useUpdatePlanMutation,
} = customizeOptions;
